export class ServerConfig {
  ipAddress = '';
  port = '';

  constructor(json:any) {
    if(json!=null) {
      this.ipAddress = json.ipAddress;
      this.port = json.port;
    }
  }

}
